import Vue from 'vue'
import Router from 'vue-router'

import Test from '@/components/Test'
import Signin from '@/view/signin'
// import Register from '@/view/signup'
import RegisterCustomer from '@/view/asCustomer'
// import RegisterMerchant from '@/view/asMerchant'
import SignupVerification from '@/view/signupVerification'
import Dashboard from '@/view/dashboard'
import InstantPrice from '@/view/instantPrice'
import RequestShipment from '@/view/requestShipment'
import VesselSchedule from '@/view/vesselSchedule'
import RequestList from '@/view/requestList'
import RequestShipmentType from '@/view/requestShipmentType'
import RequestListStatusRFQ from '@/view/requestlistDetail/rfq'
import RequestListStatusContract from '@/view/requestlistDetail/contract'
import RequestListStatusIQ from '@/view/requestlistDetail/instantQuote'
import RequestShipmentContract from '@/view/requestShipmentContract'
import ManagementShipment from '@/view/managementShipment'
import ManagementShipmentDetail from '@/view/managementShipmentDetail'
// import Payment from '@/view/payment'
import PaymentHistory from '@/view/paymentHistory'
import PaymentDetail from '@/view/paymentDetail'
import PaymentNow from '@/view/paymentNow'
import Promo from '@/view/promo'
import PromobookingForm from '@/view/PromobookingForm'
// import Tutorial from '@/view/tutorial'
import Invitation from '@/view/invitation'
import VerifyReLogin from '@/view/verifyReLogin'
import VerifyEmail from '@/view/verifyEmail'
import VerifyAcc from '@/view/verifyAcc'
import UploadPayment from '@/components/payment/paynow/UploadPayment.vue'
import Settings from '@/view/settings'
import Help from '@/view/help'
import PasswordReset from '@/view/passwordreset'
// import Bookmark from '@/view/bookmark'
import IPbookingform from '@/view/IPbookingForm'
import RFQBookingForm from '@/view/RFQBookingForm'
import ContractBookingForm from '@/view/ContractBookingForm'
import ForgotPassword from '@/view/forgotPassword'
import AndalinPoints from '@/view/andalinPoints'
import StorageCalculator from '@/view/storageCalculator'
import ContractBusinessAgreement from '@/view/ContractBusinessAgreement'
import PaymentAlibaba from '@/view/paymentAlibaba'
import CreditApplicationForm from '@/view/CreditApplicationForm'
import BookingForm from '@/view/bookingForm'
import GuestPersonalData from '@/view/guestPersonalData'
import GuestSignIn from '@/view/guestSignIn'
import NotifAndToDo from '@/view/dashboard/pages/NotifAndToDo.vue'
import auth from '../middleware/auth'
import verified from '../middleware/verified'
import guest from '../middleware/guest'
import guestOrVerified from '../middleware/guestOrVerified'
import store from '../store/index'
import middlewarePipeline from '../middleware/middlewarePipeline'
import Address from '@/view/settings/Address.vue'
import Documents from '@/view/settings/Documents.vue'
import Account from '@/view/settings/Account.vue'
import BillingAddress from '@/view/billingAddress'
import FormSAF from '@/view/saf/index.vue'
import LandShipmentTracking from '@/view/landShipmentTracking'
import Warehouse from '@/view/warehouse'
import warehouseList from '@/view/warehouse/inboundList'
import warehouseDetail from '@/view/warehouse/inboundList/detail.vue'
import inventoryList from '@/view/warehouse/inventoryList'
import inventoryDetail from '@/view/warehouse/inventoryList/detail.vue'

Vue.use(Router)

export const router = new Router({
  mode: 'history',
  base: __dirname,
  routes: [
    // TEST PAGES
    { path: '/',
      name: 'Landingpage',
      component: Signin,
      meta: {
        showChat: false
      }
    },
    { path: '/test', name: 'Test', component: Test },
    // HOME
    { path: '/signin',
      name: 'Signin',
      component: Signin,
      meta: {
        showChat: false
      }
    },
    // { path: '/register',
    //   name: 'Register',
    //   component: Register
    // },
    {
      path: '/register-customer',
      name: 'RegisterCustomer',
      component: RegisterCustomer,
      meta: {
        showChat: false
      }
    },
    // {
    //   path: '/register-merchant',
    //   name: 'RegzisterMerchant',
    //   component: RegisterMerchant
    // },
    {
      path: '/register-verification',
      name: 'SignupVerification',
      component: SignupVerification,
      meta: {
        showChat: false
      }
    },
    // andalin point
    { path: '/andalinpoints',
      name: 'AndalinPoints',
      component: AndalinPoints,
      meta: {
        middleware: [auth, verified],
        showChat: false
      }
    },
    // dashboard
    { path: '/storagecalculator',
      name: 'StorageCalculator',
      component: StorageCalculator,
      meta: {
        middleware: [auth],
        showChat: false
      }
    },
    { path: '/dashboard',
      name: 'Dashboard',
      component: Dashboard,
      meta: {
        middleware: [auth, verified],
        showChat: true
      }
    },
    { path: '/new-dashboard/:type',
      name: 'NotifAndToDo',
      component: NotifAndToDo,
      meta: {
        middleware: [auth, verified],
        showChat: false
      }
    },
    { path: '/vessel-schedule',
      name: 'VesselSchedule',
      component: VesselSchedule,
      meta: {
        middleware: [auth, verified],
        showChat: false
      }
    },
    { path: '/request-list/:type/:failedType?',
      name: 'RequestList',
      component: RequestList,
      meta: {
        middleware: [auth, verified],
        showChat: false
      }
    },
    {
      path: '/request-list-status/rfq/:id_rfq/:rfqNumber',
      name: 'RequestListStatusRFQ',
      component: RequestListStatusRFQ,
      meta: {
        middleware: [auth, verified],
        showChat: false
      }
    },
    {
      path: '/request-list-status/contract/:id_contract/:contractNumber/:type?',
      name: 'RequestListStatusContract',
      component: RequestListStatusContract,
      props: true,
      meta: {
        middleware: [auth, verified],
        showChat: false
      }
    },
    {
      path: '/request-list-status/instant-quote/:id_iq/:iqNumber',
      name: 'RequestListStatusIQ',
      component: RequestListStatusIQ,
      props: true,
      meta: {
        middleware: [auth, verified],
        showChat: false
      }
    },
    // request
    { path: '/instant-price',
      name: 'InstantPrice',
      component: InstantPrice,
      props: true,
      meta: {
        middleware: [auth, verified],
        showChat: false
      } },
    {
      path: '/request-shipment/:step?/:type?/:id?', // route -> code ori city - code des city
      name: 'RequestShipment',
      component: RequestShipment,
      meta: {
        middleware: [auth, verified],
        showChat: false
      }
    },
    { path: '/request-shipment-contract/:step?/:type?/:id?',
      name: 'RequestShipmentContract',
      component: RequestShipmentContract,
      meta: {
        middleware: [auth, verified],
        showChat: false
      } },
    // manage shipment
    {
      path: '/manage-shipment/:type?/:email?/:id?',
      alias: '/manage-shipment/filter',
      name: 'ManagementShipment',
      component: ManagementShipment,
      meta: {
        middleware: [auth, verified],
        showChat: false
      }
    },
    {
      path: '/manage-shipment/:type?/detail/:id_shipment?/:order_number?/:rfqNumber?',
      name: 'ManagementShipmentDetail',
      component: ManagementShipmentDetail,
      meta: {
        middleware: [auth, guestOrVerified],
        showChat: false
      }
    },
    // Bookingform
    {
      path: '/ip-booking-form',
      name: 'IPbookingform',
      component: IPbookingform,
      meta: {
        middleware: [auth, verified],
        showChat: false
      }
    },
    {
      path: '/rfq-booking-form',
      name: 'RFQBookingForm',
      component: RFQBookingForm,
      meta: {
        middleware: [auth, verified],
        showChat: false
      }
    },
    {
      path: '/contract-booking-form',
      name: 'ContractBookingForm',
      component: ContractBookingForm,
      meta: {
        middleware: [auth, verified],
        showChat: false
      }
    },
    {
      path: '/booking-form/:type/:id?/:bidId?',
      name: 'BookingForm',
      component: BookingForm,
      meta: {
        middleware: [auth, verified],
        showChat: false
      }
    },
    // Business Agreement
    {
      path: '/contract-ba/:id_contract/:contractNumber',
      name: 'ContractBusinessAgreement',
      component: ContractBusinessAgreement,
      meta: {
        middleware: [auth, verified],
        showChat: false
      }
    },
    // Settings
    {
      path: '/settings',
      name: 'Settings',
      component: Settings,
      meta: {
        middleware: [auth],
        showChat: false
      }
    },
    {
      path: '/settings/myaddresses',
      name: 'MyAddresses',
      component: Address,
      meta: {
        middleware: [auth, verified],
        showChat: false
      }
    },
    {
      path: '/settings/myaccount',
      name: 'MyAccount',
      component: Account,
      meta: {
        middleware: [auth],
        showChat: false
      }
    },
    {
      path: '/settings/mydocuments',
      name: 'MyDocuments',
      component: Documents,
      meta: {
        middleware: [auth],
        showChat: false
      }
    },
    {
      path: '/form-saf',
      name: 'FormSAF',
      component: FormSAF,
      meta: {
        showChat: false
      }
    },
    {
      path: '/request-shipment-type',
      name: 'RequestShipmentType',
      component: RequestShipmentType,
      meta: {
        middleware: [auth, verified],
        showChat: false
      }
    },
    // Payment
    // {
    //   path: '/payment/:type?',
    //   name: 'Payment',
    //   component: Payment,
    //   meta: {
    //     middleware: [auth, verified]
    //   }
    // },
    {
      path: '/payment-history/:shipmentId/:orderNumber',
      name: 'PaymentHistory',
      component: PaymentHistory,
      meta: {
        middleware: [auth, verified],
        showChat: false
      }
    },
    {
      path: '/payment-detail/:idInvoice/:noInvoice/:type',
      name: 'PaymentDetail',
      component: PaymentDetail,
      meta: {
        middleware: [auth, verified],
        showChat: false
      }
    },
    {
      path: '/payment-full',
      name: 'PaymentNow',
      component: PaymentNow,
      meta: {
        middleware: [auth, verified],
        showChat: false
      }
    },
    {
      path: '/upload-payment',
      name: 'UploadPayment',
      component: UploadPayment,
      meta: {
        middleware: [auth, verified],
        showChat: false
      }
    },
    {
      path: '/alibaba-payment',
      name: 'PaymentAlibaba',
      component: PaymentAlibaba,
      meta: {
        middleware: [auth, verified],
        showChat: false
      }
    },
    // Promo
    {
      path: '/promo',
      name: 'Promo',
      component: Promo,
      meta: {
        middleware: [auth, verified],
        showChat: false
      }
    },
    {
      path: '/promo-booking-form',
      name: 'PromobookingForm',
      component: PromobookingForm,
      meta: {
        middleware: [auth, verified],
        showChat: false
      }
    },

    // Help
    {
      path: '/help',
      name: 'Help',
      component: Help,
      meta: {
        middleware: [auth],
        showChat: false
      }
    },

    // Password Reset && Forgot Password
    {
      path: '/password-reset',
      name: 'PasswordReset',
      component: PasswordReset,
      meta: {
        showChat: false
      }
    },
    {
      path: '/forgot-password',
      name: 'ForgotPassword',
      component: ForgotPassword,
      meta: {
        showChat: false
      }
    },

    // Bookmark
    // {
    //   path: '/bookmark',
    //   name: 'Bookmark',
    //   component: Bookmark,
    //   meta: {
    //     middleware: [auth, verified]
    //   }
    // },

    // Tutorial
    // {
    //   path: '/tutorial',
    //   name: 'Tutorial',
    //   component: Tutorial,
    //   meta: {
    //     middleware: [auth, verified],
    //     showChat: false
    //   }
    // },

    // Invitation
    {
      path: '/invitation',
      name: 'Invitation',
      component: Invitation,
      meta: {
        showChat: false
      }
    },

    // Credit Application Form
    {
      path: '/caf',
      name: 'CreditApplicationForm',
      component: CreditApplicationForm,
      meta: {
        middleware: [auth, verified],
        showChat: false
      }
    },

    // verification
    {
      path: '/verify-relogin',
      name: 'VerifyReLogin',
      component: VerifyReLogin,
      meta: {
        showChat: false
      }
    },
    {
      path: '/verify-email',
      name: 'VerifyEmail',
      component: VerifyEmail,
      meta: {
        showChat: false
      }
    },
    {
      path: '/verify-account',
      name: 'VerifyAcc',
      component: VerifyAcc,
      meta: {
        showChat: false
      }
    },
    // Guest Personal Data
    {
      path: '/guest-personal-data',
      name: 'GuestPersonalData',
      component: GuestPersonalData,
      meta: {
        middleware: [auth, guest],
        showChat: false
      }
    },
    {
      path: '/guest',
      name: 'GuestSignIn',
      component: GuestSignIn,
      meta: {
        showChat: false
      }
    },

    // otherwise go to home
    { path: '*', 
      redirect: '/dashboard',
      meta: {
        showChat: false
      } 
    },

    // billing address
    {
      path: '/billing-address',
      name: 'BillingAddress',
      component: BillingAddress,
      meta: {
        showChat: false
      }
    },
    // truck tracking
    {
      path: '/land-shipment/tracking/:idTracking',
      name: 'LandShipmentTracking',
      component: LandShipmentTracking,
      meta: {
        middleware: [auth, verified],
        showChat: false
      }
    },
    {
      path: '/warehouse/:type', // route -> code ori city - code des city
      name: 'Warehouse',
      component: Warehouse,
      meta: {
        middleware: [auth, verified],
        showChat: false
      }
    },
    { path: '/warehouse-list/:type',
      name: 'warehouseList',
      component: warehouseList,
      meta: {
        middleware: [auth, verified],
        showChat: false
      }
    },
    { path: '/warehouse-list/:type/detail/:id',
      name: 'warehouseDetail',
      component: warehouseDetail,
      meta: {
        middleware: [auth, verified],
        showChat: false
      }
    },
    { path: '/inventory-list/:type',
      name: 'inventoryList',
      component: inventoryList,
      meta: {
        middleware: [auth, verified],
        showChat: false
      }
    },
    { path: '/inventory-list/:type/detail/:id',
      name: 'inventoryDetail',
      component: inventoryDetail,
      meta: {
        middleware: [auth, verified],
        showChat: false
      }
    }
  ]
})

router.beforeEach((to, from, next) => {
  if (!to.meta.middleware) {
    return next()
  } else {
    if (localStorage.getItem('token') == null) {
      localStorage.setItem('history', router.history._startLocation)
      next({
        path: '/signin', params: { nextUrl: to.fullPath }
      })
    } else {
      return next()
    }
  }
  const middleware = to.meta.middleware

  const context = {
    to,
    from,
    next,
    router,
    store
  }

  return middleware[0]({
    ...context,
    next: middlewarePipeline(context, middleware, 1)
  })
})

// router.afterEach((to) => {
//   window.tidioChatApi &&
//   window.tidioChatApi.display(to.meta.showChat)
// })



// WEBPACK FOOTER //
// ./src/router/index.js